import api from './index';

export const productsAPI = {
  // Get all products
  getProducts: (params = {}) => {
    return api.get('/products/', { params });
  },
  
  // Get featured products
  getFeaturedProducts: () => {
    return api.get('/products/featured/');
  },
  
  // Get single product
  getProduct: (slug) => {
    return api.get(`/products/${slug}/`);
  },
  
  // Get categories
  getCategories: () => {
    return api.get('/products/categories/');
  },
  
  // Get category detail
  getCategory: (slug) => {
    return api.get(`/products/categories/${slug}/`);
  },
  
  // Admin: Create product
  createProduct: (data) => {
    return api.post('/products/admin/products/', data);
  },
  
  // Admin: Update product
  updateProduct: (id, data) => {
    return api.put(`/products/admin/products/${id}/`, data);
  },
  
  // Admin: Delete product
  deleteProduct: (id) => {
    return api.delete(`/products/admin/products/${id}/`);
  },
  
  // Admin: Create category
  createCategory: (data) => {
    return api.post('/products/categories/', data);
  },
  
  // Admin: Update category
  updateCategory: (id, data) => {
    return api.put(`/products/categories/${id}/`, data);
  },
  
  // Admin: Delete category
  deleteCategory: (id) => {
    return api.delete(`/products/categories/${id}/`);
  }
};